import React from 'react'

import * as ArticleComponents from 'components/ArticleComponents'
import Copyable from 'components/Copyable'

import Data from '../TestCards.yaml'

const successfulAuthorizationCards = Data.cards.primerTestProcessor.filter(card => !card.authorizationOutcome)
const failedOrDeclinedAuthorizationCards = Data.cards.primerTestProcessor.filter(card => !!card.authorizationOutcome)

const getCardNetworkName = networkId => Data.cardNetworks[networkId]?.name ?? networkId
const getFullAuthorizationOutcome = authorizationOutcomeId =>
	Data.authorizationOutcomes[authorizationOutcomeId] ?? authorizationOutcomeId

const CardNumber = ({ value }) => (
	<Copyable value={value}>
		<ArticleComponents.Code>{value}</ArticleComponents.Code>
	</Copyable>
)

const TestCardsSection = () => {
	return (
		<>
			<ArticleComponents.P>
				For test card payments, you can use the following test cards to simulate scenarios:
			</ArticleComponents.P>

			{/* Successful Auth */}
			<ArticleComponents.H5>Successful authorization</ArticleComponents.H5>
			<ArticleComponents.P>Use the following test cards to simulate a successful authorization.</ArticleComponents.P>

			<ArticleComponents.HorizontalScrollTable>
				<thead>
					<tr>
						<th>Card Network</th>
						<th>Card Number</th>
						<th>CVV</th>
						<th>Expiry date</th>
						<th>Account Funding Type</th>
					</tr>
				</thead>

				<tbody>
					{successfulAuthorizationCards.map(card => (
						<tr key={card.number}>
							<td>{getCardNetworkName(card.network)}</td>
							<td>
								<CardNumber value={card.number} />
							</td>
							<td>Any 3 digit number</td>
							<td>Any future expiry date</td>
							<td>
								{card.accountFundingType}
							</td>
						</tr>
					))}
				</tbody>
			</ArticleComponents.HorizontalScrollTable>

			{/* Failed or Declined Auth */}

			<ArticleComponents.H5>Failed and declined authorization</ArticleComponents.H5>
			<ArticleComponents.P>
				Use the following test cards to simulate a failed or declined authorization.
			</ArticleComponents.P>

			<ArticleComponents.HorizontalScrollTable>
				<thead>
					<tr>
						<th>Scenario</th>
						<th>Card Network</th>
						<th>Card Number</th>
					</tr>
				</thead>

				<tbody>
					{failedOrDeclinedAuthorizationCards.map(card => (
						<tr key={card.number}>
							<td>{getFullAuthorizationOutcome(card.authorizationOutcome)}</td>
							<td>{getCardNetworkName(card.network)}</td>
							<td>
								<CardNumber value={card.number} />
							</td>
						</tr>
					))}
				</tbody>
			</ArticleComponents.HorizontalScrollTable>
		</>
	)
}

export default TestCardsSection
